import React, {Fragment} from "react";
import {Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {getFormFieldValue, StateList} from '../shared/shared';
import {getData} from "../../../api/doLogin";

export function Address(props) {
  const {values, handleCB, readonly, token, formFields, thisId} = props;

  function setValue(field, value) {
    if (readonly) return;
    handleCB(field, value);
  };

  function fetchZipDetails(zip, city, state) {
    if (readonly) return;
    if (zip.length === 0) {
      var objPost = {
        ...values,
        [city]: "",
        [state]: ""
      }
      handleCB(objPost);
      return;
    }
    getData("zip/get?zip=" + zip, {}, token)
      .then((data) => {
        if (data.status == "Success") {
          console.log(data.data);
          if (data.data.zipDetails.hasOwnProperty("city") && data.data.zipDetails.hasOwnProperty("state")) {

            setValue({[city]: data.data.zipDetails.city, [state]: data.data.zipDetails.state}, null);
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  }


  return (
    <Fragment>
      <Row>
        <Col xs={"7"}>
          <FormGroup>
            <Label htmlFor={thisId + "Address"}>Street&nbsp;Address{thisId === "bank" ? "" : "*"}</Label>
            <Input type="text" id={thisId + "Address"} placeholder=""
                   value={getFormFieldValue(values[thisId + "Address"])}
                   onChange={(evt) => setValue(evt.target.id, evt.target.value)}/>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={"2"}>
          <FormGroup>
            <Label htmlFor={thisId + "Zip"}>Zip{thisId === "bank" ? "" : "*"}</Label>
            <Input type="text" id={thisId + "Zip"} placeholder=""
                   value={getFormFieldValue(values[thisId + "Zip"])}
                   onChange={(evt) => setValue(evt.target.id, evt.target.value)}
                   onBlur={(evt) => fetchZipDetails(evt.target.value, thisId + "City", thisId + "State")}/>
            <FormText color="muted">
              will autofill city/state
            </FormText>
          </FormGroup>
        </Col>
        <Col xs={"3"}>
          <FormGroup>
            <Label htmlFor={thisId + "City"}>City</Label>
            <Input type="text" id={thisId + "City"} placeholder=""
                   value={getFormFieldValue(values[thisId + "City"])}
                   onChange={(evt) => setValue(evt.target.id, evt.target.value)}/>
          </FormGroup>
        </Col>
        <Col xs={"2"}>
          <FormGroup>
            <Label htmlFor={thisId + "State"}>State</Label>
            <Input type="select" name={thisId + "State"} id={thisId + "State"}
                   value={getFormFieldValue(values[thisId + "State"])}
                   onChange={(evt) => setValue(evt.target.id, evt.target.value)}>
              <option key={0} value={""} disabled={true}>Choose</option>
              {StateList.map((value, index) => {
                return (
                  <option key={index + 1} value={value.id}>{value.display}</option>
                )
              })}
            </Input>
          </FormGroup>
        </Col>
      </Row>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Applications/components/Address.js